import { useTranslation } from 'react-i18next';
import { Accomplishment, Record } from '../../../contexts/interfaces';
import classes from './DoctorAttachedAccomplishments.module.css';
import openFile from '../../../scripts/openFile';

interface Props {
    accomplishments: Accomplishment[],
    attachments: Record[]
}

const DoctorAttachedAccomplishments = ({ accomplishments, attachments }: Props) => {

    const { t } = useTranslation();

    return (
        <div className={classes.container}>
            {
                `${t('doctorAttachedAccomplishments.forFollowingAttachments')} ${accomplishments.filter(acc => acc.fromAttachment === true).map(accomplishment =>
                    " " + accomplishment.title)}:`
            }

            {
                attachments.map((attachment, i) => {
                    return (
                        <div
                            key={i}
                            className={classes.attachmentTitle}
                            onClick={() => openFile(attachment.file)}
                        >
                            {attachment.title}
                        </div>
                    )
                })
            }

        </div>
    )
};

export default DoctorAttachedAccomplishments;